import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { Customer } from '../models/customer';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  token:any;
  //REF SECTORS VARIABLES
  sectorsSubject:Subject<any>;
  pathApiSectors:string="/v1/ref/sectors";
  urlRequestSectorsRef: string =urlServer.concat(this.pathApiSectors);
  //REF CITIES VARIABLES
  refCitiesSubject:Subject<any>;
  pathApiCities:string="/v1/ref/cities";
  urlRequestCitiesRef: string =urlServer.concat(this.pathApiCities);
  //REF CUSTOMERS VARIABLES
  customersSubject:Subject<any>;
  pathApiAllCustomers:string="/v1/customers";
  urlRequestCustomersRef: string =urlServer.concat(this.pathApiAllCustomers);
  //REF NEW CUSTOMER VARIABLES
  newCustomerSubject:Subject<any>;
  //REF DELETE CUSTOMER VARIABLES
  deleteCustomerSubject:Subject<any>;
  //REF ARCHIVE CUSTOMER VARIABLES
  archiveCustomerSubject:Subject<any>;
  //REF UPDATE CUSTOMER VARIABLES
  updateCustomerSubject:Subject<any>;
  //INDICATORS VARIABLES
  indicatorsSubject:Subject<any>;
  pathApiIndicatorsCustomers:string="/v1";
  urlRequestIndicatorsCustomers: string =urlServer.concat(this.pathApiIndicatorsCustomers);
  //INDICATORS CLASSIFICATION CUSTOMERS VARIABLES
  customClassesIndicatorSubject:Subject<any>;
  pathApiIndicatorsClasses:string="/v1/customers/classes";
  urlRequestIndicatorsClasses: string =urlServer.concat(this.pathApiIndicatorsClasses);

  pathApiAllCustomer:string="/v1/customer";
  urlRequestCustomerRef: string =urlServer.concat(this.pathApiAllCustomer);

  //FILTER LIST OF CUSTOMERS VARIABLES
  customersFilterSubscription:Subject<any>;
  pathApicustomersFilter:string="/v1/customers/commercial";
  urlRequestcustomersFilter: string =urlServer.concat(this.pathApicustomersFilter);

  //FILTER LIST OF ARCHIVED CUSTOMERS
  archivedCustomersFilterSubscription:Subject<any>;
  pathApiArchivedcustomers:string="/v1/customers/archived/commercial";
  urlRequestArchivedcustomersFilter: string =urlServer.concat(this.pathApiArchivedcustomers);

  constructor(private httpClient:HttpClient) {
    this.sectorsSubject = new Subject();
    this.refCitiesSubject = new Subject();
    this.customersSubject = new Subject();
    this.newCustomerSubject = new Subject();
    this.deleteCustomerSubject = new Subject();
    this.archiveCustomerSubject = new Subject();
    this.updateCustomerSubject = new Subject();
    this.indicatorsSubject = new Subject();
    this.customClassesIndicatorSubject = new Subject();
    this.customersFilterSubscription = new Subject();
    this.archivedCustomersFilterSubscription = new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
  }

  getSectors(){
    this.sectorsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestSectorsRef,{headers: header}).subscribe((response: any) => {
      this.sectorsSubject.next(response);
      this.sectorsSubject.complete();
    },error => {
    });
  }
  getCities(){
    this.refCitiesSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestCitiesRef,{headers: header}).subscribe((response: any) => {
      this.refCitiesSubject.next(response);
      this.refCitiesSubject.complete();
    },error => {
    });
  }
  getRefCities() {
    this.refCitiesSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestCitiesRef,{headers: header}).subscribe((response: any) => {
      this.refCitiesSubject.next(response);
      this.refCitiesSubject.complete();
    },error => {
    });
  }
  getAllCustomers(){
    this.customersSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestCustomersRef,{headers: header}).subscribe((response: any) => {
      this.customersSubject.next(response);
      this.customersSubject.complete();
    },error => {
    });
  }
  newCustomerRequest:any;
  newCustomer() {
    this.newCustomerSubject = new Subject();
    const body = this.newCustomerRequest;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestCustomersRef+"/customer", body,{headers: header}).subscribe((response: any) => {
        this.newCustomerSubject.next(response);
        this.newCustomerSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  deleteCustomer(uuid:any) {
    this.deleteCustomerSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.delete(this.urlRequestCustomersRef+"/customer/"+uuid,{headers: header}).subscribe((response: any) => {
        this.deleteCustomerSubject.next(response);
        this.deleteCustomerSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  archiveCustomer(uuid:any) {
    this.archiveCustomerSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(this.urlRequestCustomersRef+"/customer/archive/"+uuid,null,{headers: header}).subscribe((response: any) => {
        this.archiveCustomerSubject.next(response);
        this.archiveCustomerSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  updateCustomerRequest:any;
  updateCustomer(uuid:any) {
    this.updateCustomerSubject = new Subject();
    const body = this.updateCustomerRequest;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(this.urlRequestCustomersRef+"/customer/"+uuid, body,{headers: header}).subscribe((response: any) => {
        this.updateCustomerSubject.next(response);
        this.updateCustomerSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  getIndicatorsCustomers(){
    this.indicatorsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestIndicatorsCustomers+"/indicators/customers",{headers: header}).subscribe((response: any) => {
        this.indicatorsSubject.next(response);
        this.indicatorsSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  getIndicatorsClassesCustomers() {
    this.customClassesIndicatorSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestIndicatorsClasses,{headers: header}).subscribe((response: any) => {
        this.customClassesIndicatorSubject.next(response);
        this.customClassesIndicatorSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getCustomerConversationUrl=`${urlServer}/v1/conversation/customer/`;
  getCustomerConversation(customerUuid:string) {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return this.httpClient.get(this.getCustomerConversationUrl+customerUuid,{headers: header});
  }
  SendCommentUrl=`${urlServer}/v1/message/customer/`;
  sendMessage(customerUuid:string, body: any) {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return this.httpClient.post(this.SendCommentUrl+customerUuid,body,{headers: header});
  }

  getCommercialCustomers(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token);
    return this.httpClient.get<ServiceResponse>(`${this.urlRequestCustomersRef}/commercial`, {headers: header});
  }

  searchCustomer(body: Customer): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token);
    return this.httpClient.post<ServiceResponse>(`${this.urlRequestCustomersRef}/search`,body, {headers: header});
  }

  getClassesIndicatorsOfCommercialCustomers(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token);
    return this.httpClient.get<ServiceResponse>(`${this.urlRequestCustomersRef}/smart/commercial`, {headers: header});
  }

  getCommercialCustomersIndicators(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token);
    return this.httpClient.get<ServiceResponse>(`${this.urlRequestCustomersRef}/size`, {headers: header});
  }
  getCompanyCustomersIndicators(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token);
    return this.httpClient.get<ServiceResponse>(`${this.urlRequestCustomersRef}/company/size`, {headers: header});
  }
  retrieveCustomer(uuid:string, filter?: string){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token);
    let params: any = {};
      if (filter) {
        params.filter = filter;
      }
    return this.httpClient.get(`${this.urlRequestCustomerRef}/${uuid}`, {headers: header, params: params} );
  }
  getCustomerByCritary(critary:any){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token);
    // return this.httpClient.get(`${this.urlRequestCustomerRef}/${uuid}`, {headers: header});
  }
  getCustomersOfCommercial(commercial:any,classe:any){
    // let header: HttpHeaders = new HttpHeaders();
    // header = header.set('authorization', "Bearer "+this.token);
    // return this.httpClient.get(`${this.urlRequestcustomersFilter}/${commercial}`, {headers: header});
    console.log(classe);
    if(classe==null){
      classe="";
    }
    this.customersFilterSubscription = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(`${this.urlRequestcustomersFilter}/${commercial}${classe}`,{headers: header}).subscribe((response: any) => {
        this.customersFilterSubscription.next(response);
        this.customersFilterSubscription.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  getArchivedCustomers(critary:any){
    this.archivedCustomersFilterSubscription = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(`${this.urlRequestArchivedcustomersFilter}/${critary}`,{headers: header}).subscribe((response: any) => {
        this.archivedCustomersFilterSubscription.next(response);
        this.archivedCustomersFilterSubscription.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  
}
